import { configurarClienteBanco } from "./dbClient";
import { createClient } from "@supabase/supabase-js";
import { envValidator } from "@shared/config/envValidator";
import { logger } from "@shared/logging/logger";

const env = envValidator.getEnv();

export const SUPABASE_URL = env.SUPABASE_URL || "https://rdhdfjvyksnozmmespsy.supabase.co";
export const SUPABASE_ANON_KEY = env.SUPABASE_ANON_KEY || "sb_publishable_Yufm2DREV9Qz3GYWD8InBA_gSG_mtbV";
// A service role NUNCA deve ser lida aqui: este módulo vai para o bundle do navegador,
// e qualquer referência a import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY a publicaria.
// Acesso privilegiado é só no backend (DatabaseClient.getAdminClient()).

// Custom storage to handle "Keep me logged in"
const customStorage = {
  getItem: (key: string): string | null => {
    if (typeof window === 'undefined') return null;
    const localVal = window.localStorage.getItem(key);
    if (localVal !== null) return localVal;
    return window.sessionStorage.getItem(key);
  },
  setItem: (key: string, value: string): void => {
    if (typeof window === 'undefined') return;
    const rememberMe = window.localStorage.getItem('wm_remember_me') === 'true';
    if (rememberMe) {
      window.localStorage.setItem(key, value);
    } else {
      window.sessionStorage.setItem(key, value);
    }
  },
  removeItem: (key: string): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  },
};

let supabaseInstance: any = null;

export const getSupabase = () => {
  if (!supabaseInstance) {
    const rawInstance = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        storage: customStorage,
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
      }
    });

    // Debug auth events via central logger
    rawInstance.auth.onAuthStateChange((event: string, session: any) => {
      if (event === 'TOKEN_REFRESHED') {
        logger.debug('supabase_client', 'Supabase token refreshed successfully');
      } else if (event === 'SIGNED_OUT') {
        logger.debug('supabase_client', 'Supabase user signed out');
      } else if (event === 'SIGNED_IN') {
        logger.debug('supabase_client', 'Supabase user signed in', { userId: session?.user?.id });
      }
    });

    supabaseInstance = rawInstance;
  }
  return supabaseInstance;
};

export const supabase = getSupabase();
configurarClienteBanco(supabase);
export const supabaseAdmin = supabase;
export const supabaseInvite = supabase;
